export default function Header () {

  return (
    <main>
      <h1>React Counter App</h1>
      <p>React Web app studying useState() in React.</p>
    </main>
  )
}